import { STARTING_RATING } from "./elo";

export const RATING_HISTORY_KEY = "alatriviaRatingHistory";
export const MAX_RATING_SNAPSHOTS = 5000;

export function loadRatingHistory() {
  try {
    const stored = localStorage.getItem(
      RATING_HISTORY_KEY
    );

    if (!stored) {
      return [];
    }

    const parsed = JSON.parse(stored);

    return Array.isArray(parsed)
      ? parsed
      : [];
  } catch (error) {
    console.error(
      "Could not load rating history:",
      error
    );

    return [];
  }
}

export function saveRatingSnapshot(ratings) {
  const history = loadRatingHistory();

  const categories = Object.fromEntries(
    Object.entries(
      ratings?.categories ?? {}
    )
      .filter(
        ([, data]) =>
          Number.isFinite(data?.rating)
      )
      .map(([categoryId, data]) => [
        categoryId,
        {
          r: data.rating,
          a: data.attempts ?? 0,
        },
      ])
  );

  const snapshot = {
    t: Date.now(), //timestamp

    o: //overall rating
      ratings?.overall ??
      STARTING_RATING,

    c: categories,
  };

  const updatedHistory = [
    ...history,
    snapshot,
  ].slice(-MAX_RATING_SNAPSHOTS);

  localStorage.setItem(
    RATING_HISTORY_KEY,
    JSON.stringify(updatedHistory)
  );

  return snapshot;
}

export function ensureRatingHistoryBaseline(
  ratings
) {
  const history = loadRatingHistory();

  if (history.length > 0) {
    return;
  }

  saveRatingSnapshot(ratings);
}